module.exports = __webpack_public_path__ + "img/logo-06.35a54f2a.svg";